import React from 'react';
import { MantineProvider } from '@mantine/core';
import { mantineTheme } from '@shared/theme';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  // Apply dark mode class to html element to ensure CSS overrides work
  React.useEffect(() => {
    const applyDarkModeClass = () => {
      const html = document.documentElement;
      const colorScheme = html.getAttribute('data-mantine-color-scheme');

      if (colorScheme === 'dark') {
        html.classList.add('agilex-dark-mode');
      } else {
        html.classList.remove('agilex-dark-mode');
      }
    };

    // Initial application
    applyDarkModeClass();

    // Watch for changes to color scheme
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-mantine-color-scheme'
        ) {
          applyDarkModeClass();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-mantine-color-scheme'],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <MantineProvider theme={mantineTheme} defaultColorScheme="auto">
      {children}
    </MantineProvider>
  );
}
